import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { SimulateCommissionRequestDto } from '@domain/company-collector-commission-rule/dtos/simulate-commission-request.dto';
import { SimulateCommissionResponseDto } from '@domain/company-collector-commission-rule/dtos/simulate-commission-response.dto';

@Injectable({
  providedIn: 'root',
})
export class CompanyCollectorCommissionRuleService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('company/collector');
  }

  simulate(request: SimulateCommissionRequestDto) {
    const queryUrl = `${this.getApiUrl()}/commission-rules/simulate`;
    return this.http.post<ApiResponse<SimulateCommissionResponseDto>>(
      queryUrl,
      request,
    );
  }
}
